
const config = {
  apiBasePath: window.__RUNTIME_CONFIG__.REACT_APP_API_BASE_PATH || 'http://localhost:8000',
  reactAppMode: window.__RUNTIME_CONFIG__.REACT_APP_MODE || 'dev',
};

export default config;